import { warning } from '@/utils/alert'

export default {
  receituarioMake () {
    warning('Módule em desenvolvimento')
    return false
  },
  atestadoMake () {
    warning('Módule em desenvolvimento')
    return false
  },
  avaliarMake () {
    warning('Módule em desenvolvimento')
    return false
  },
  encaminharMake () {
    warning('Módule em desenvolvimento')
    return false
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/components/consultations-made/resources/methods.js